import confetti from 'canvas-confetti';

const duration = 15000;
const animationEnd = Date.now() + duration;
const defaults = {
    startVelocity: 25,
    spread       : 1200,
    ticks        : 300,
    zIndex       : 50
};

const randomInRange = ( min, max ) => Math.random() * ( max - min ) + min;

let interval = setInterval( () => {
    let timeLeft = animationEnd - Date.now();

    if ( timeLeft <= 0 ) {
        return clearInterval( interval );
    }

    let particleCount = 50 * ( timeLeft / duration );

    confetti( Object.assign( {}, defaults, {
        particleCount,
        origin: {
            x: randomInRange( 0.1, 0.3 ),
            y: Math.random() - 0.2
        }
    } ) );

    confetti( Object.assign( {}, defaults, {
        particleCount,
        origin: {
            x: randomInRange( 0.7, 0.9 ),
            y: Math.random() - 0.2
        }
    } ) );
}, 550 );
